(function() {
  'use strict';

  var GT_OFFSET = -6;
  var DAYS_ES = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
  var MONTHS_ES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];

  function getNowGT() {
    var now = new Date();
    var utc = now.getTime() + now.getTimezoneOffset() * 60000;
    return new Date(utc + GT_OFFSET * 3600000);
  }

  function pointInPolygon(point, polygon) {
    var x = point[0], y = point[1];
    var inside = false;
    for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      var xi = polygon[i][0], yi = polygon[i][1];
      var xj = polygon[j][0], yj = polygon[j][1];
      var intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }

  function pointInGeometry(lng, lat, geometry) {
    var point = [lng, lat];
    if (geometry.type === 'Polygon') {
      return pointInPolygon(point, geometry.coordinates[0]);
    } else if (geometry.type === 'MultiPolygon') {
      for (var p = 0; p < geometry.coordinates.length; p++) {
        if (pointInPolygon(point, geometry.coordinates[p][0])) return true;
      }
    }
    return false;
  }

  var geoCache = {};

  function loadGeoJSON(url) {
    if (geoCache[url]) return Promise.resolve(geoCache[url]);
    return fetch(url)
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(data) {
        geoCache[url] = data;
        return data;
      });
  }

  function findCityZone(lat, lng, config) {
    var urls = config.geoJsonUrls;
    if (!urls.zonasCiudad) return Promise.resolve(null);
    return loadGeoJSON(urls.zonasCiudad).then(function(data) {
      for (var i = 0; i < data.features.length; i++) {
        var feat = data.features[i];
        if (pointInGeometry(lng, lat, feat.geometry)) {
          return feat.properties.name || null;
        }
      }
      return null;
    }).catch(function() { return null; });
  }

  function findDeliveryZone(lat, lng, config) {
    var urls = config.geoJsonUrls;
    return Promise.all([
      loadGeoJSON(urls.zonaMensajero),
      loadGeoJSON(urls.zonaXela),
      loadGeoJSON(urls.municipios)
    ]).then(function(results) {
      var zonaMensajero = results[0];
      var zonaXela = results[1];
      var municipios = results[2];

      var inMensajero = false;
      for (var i = 0; i < zonaMensajero.features.length; i++) {
        if (pointInGeometry(lng, lat, zonaMensajero.features[i].geometry)) {
          inMensajero = true;
          break;
        }
      }

      var inXela = false;
      for (var i = 0; i < zonaXela.features.length; i++) {
        if (pointInGeometry(lng, lat, zonaXela.features[i].geometry)) {
          inXela = true;
          break;
        }
      }

      var municipio = null;
      var departamento = null;
      for (var i = 0; i < municipios.features.length; i++) {
        var feat = municipios.features[i];
        if (pointInGeometry(lng, lat, feat.geometry)) {
          municipio = feat.properties.municipio || feat.properties.MUNICIPIO || '';
          departamento = feat.properties.departamen || feat.properties.DEPARTAMEN || feat.properties.departamento || '';
          break;
        }
      }

      if (!municipio && !inMensajero && !inXela) {
        return { zone: 'outside', municipio: null, departamento: null, cityZone: null };
      }

      if (inMensajero) {
        var isGuatemalaCity = municipio && municipio.toLowerCase() === 'guatemala';
        if (isGuatemalaCity) {
          return findCityZone(lat, lng, config).then(function(cityZone) {
            return {
              zone: 'messenger_ciudad',
              municipio: municipio,
              departamento: departamento,
              cityZone: cityZone
            };
          });
        }
        return {
          zone: 'messenger',
          municipio: municipio,
          departamento: departamento,
          cityZone: null
        };
      }

      if (inXela) {
        return {
          zone: 'messenger_xela',
          municipio: municipio,
          departamento: departamento,
          cityZone: null
        };
      }

      return {
        zone: 'cargo_expreso',
        municipio: municipio,
        departamento: departamento,
        cityZone: null
      };
    });
  }

  function isValidTime(str) {
    if (!str || str === 'cerrado') return false;
    var parts = str.split(':');
    if (parts.length !== 2) return false;
    var h = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    return !isNaN(h) && !isNaN(m) && h >= 0 && h <= 23 && m >= 0 && m <= 59;
  }

  function parseBusinessHours(config) {
    var days = ['sun','mon','tue','wed','thu','fri','sat'];
    var hours = {};
    for (var i = 0; i < days.length; i++) {
      var d = days[i];
      var open = config.hours[d + '_open'] || '';
      var close = config.hours[d + '_close'] || '';
      if (isValidTime(open) && isValidTime(close)) {
        hours[i] = {
          open: parseTime(open),
          close: parseTime(close)
        };
      } else {
        hours[i] = null;
      }
    }
    return hours;
  }

  function parseTime(str) {
    var parts = str.split(':');
    return { h: parseInt(parts[0], 10), m: parseInt(parts[1], 10) };
  }

  function timeToMinutes(t) {
    return t.h * 60 + t.m;
  }

  function isBusinessDay(date, bh) {
    return bh[date.getDay()] !== null;
  }

  function addBusinessDays(date, days, bh) {
    var result = new Date(date.getTime());
    result.setHours(0, 0, 0, 0);
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (isBusinessDay(result, bh)) added++;
    }
    return result;
  }

  function nextBusinessOpen(date, bh, cutoff) {
    cutoff = cutoff || 0;
    var d = new Date(date.getTime());
    var dayInfo = bh[d.getDay()];
    if (dayInfo) {
      var nowMin = d.getHours() * 60 + d.getMinutes();
      var effectiveClose = timeToMinutes(dayInfo.close) - cutoff;
      if (nowMin < effectiveClose) {
        if (nowMin >= timeToMinutes(dayInfo.open)) {
          return d;
        } else {
          d.setHours(dayInfo.open.h, dayInfo.open.m, 0, 0);
          return d;
        }
      }
    }
    d.setDate(d.getDate() + 1);
    d.setHours(0, 0, 0, 0);
    for (var attempt = 0; attempt < 14; attempt++) {
      var info = bh[d.getDay()];
      if (info) {
        d.setHours(info.open.h, info.open.m, 0, 0);
        return d;
      }
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  function calculateEstimate(zoneInfo, productType, config, now) {
    if (!now) now = getNowGT();
    var bh = parseBusinessHours(config);
    var cutoff = parseInt(config.cutoff, 10) || 0;
    var baseDate = new Date(now.getTime());

    if (productType === 'backorder') {
      baseDate = addBusinessDays(now, 7, bh);
      baseDate.setHours(now.getHours(), now.getMinutes(), 0, 0);
    } else if (productType === 'slowback') {
      baseDate = addBusinessDays(now, 10, bh);
      baseDate.setHours(now.getHours(), now.getMinutes(), 0, 0);
    }

    var zone = zoneInfo.zone;
    var result = {};

    if (productType === 'xela') {
      if (zone === 'messenger_xela') {
        var minutes = parseInt(config.minutes.messenger_xela, 10) || 60;
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var deliveryTime = new Date(dispatchDate.getTime() + minutes * 60000);
        result.method = 'Mensajero';
        result.date = deliveryTime;
        result.type = 'messenger';
      } else {
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var arrivalDate = addBusinessDays(dispatchDate, 1, bh);
        var dayInfo = bh[arrivalDate.getDay()];
        if (dayInfo) {
          arrivalDate.setHours(dayInfo.open.h, dayInfo.open.m, 0, 0);
        }
        result.method = 'Cargo Expreso';
        result.date = arrivalDate;
        result.type = 'cargo';
      }
    } else {
      if (zone === 'messenger_ciudad') {
        var minutes = parseInt(config.minutes.messenger_ciudad, 10) || 60;
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var deliveryTime = new Date(dispatchDate.getTime() + minutes * 60000);
        result.method = 'Mensajero';
        result.date = deliveryTime;
        result.type = 'messenger';
      } else if (zone === 'messenger') {
        var minutes = parseInt(config.minutes.messenger, 10) || 90;
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var deliveryTime = new Date(dispatchDate.getTime() + minutes * 60000);
        result.method = 'Mensajero';
        result.date = deliveryTime;
        result.type = 'messenger';
      } else if (zone === 'messenger_xela') {
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var arrivalDate = addBusinessDays(dispatchDate, 1, bh);
        var dayInfo = bh[arrivalDate.getDay()];
        if (dayInfo) {
          arrivalDate.setHours(dayInfo.open.h, dayInfo.open.m, 0, 0);
        }
        result.method = 'Cargo Expreso';
        result.date = arrivalDate;
        result.type = 'cargo';
      } else if (zone === 'cargo_expreso') {
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var arrivalDate = addBusinessDays(dispatchDate, 1, bh);
        var dayInfo = bh[arrivalDate.getDay()];
        if (dayInfo) {
          arrivalDate.setHours(dayInfo.open.h, dayInfo.open.m, 0, 0);
        }
        result.method = 'Cargo Expreso';
        result.date = arrivalDate;
        result.type = 'cargo';
      } else {
        return null;
      }
    }

    var locLabel = zoneInfo.cityZone || zoneInfo.municipio || '';
    if (locLabel) locLabel = shortenMuniName(locLabel);
    result.formatted = formatDate(result.date, result.type, locLabel);
    result.municipio = zoneInfo.municipio;
    result.departamento = zoneInfo.departamento;
    return result;
  }

  function shortenMuniName(name) {
    if (!name) return name;
    var s = name;
    s = s.replace(/^(El|La)\s+/i, '');
    s = s.replace(/\bSanta\s+/g, 'Sta. ');
    s = s.replace(/\bSanto\s+/g, 'Sto. ');
    s = s.replace(/\bSan\s+/g, 'S. ');
    var words = {
      'Pedro':'P.','José':'J.','Jose':'J.','Juan':'J.','Marcos':'M.',
      'Pablo':'P.','Francisco':'F.','Miguel':'M.','Antonio':'A.',
      'Martín':'M.','Martin':'M.','Lucas':'L.','Bartolomé':'B.',
      'Bartolome':'B.','Cristóbal':'C.','Cristobal':'C.','Andrés':'A.',
      'Andres':'A.','Mateo':'M.','Felipe':'F.','Bernardino':'B.',
      'Agustín':'A.','Agustin':'A.','Raymundo':'R.','Benito':'B.'
    };
    Object.keys(words).forEach(function(w) {
      s = s.replace(new RegExp('\\b' + w + '\\b', 'g'), words[w]);
    });
    return s.replace(/\s{2,}/g, ' ').trim();
  }

  function formatDate(date, type, locationLabel) {
    var now = getNowGT();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var dateDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var diffDays = Math.round((dateDay - today) / 86400000);

    var dayName;
    if (diffDays === 0) {
      dayName = 'hoy';
    } else if (diffDays === 1) {
      dayName = 'mañana';
    } else if (diffDays === 2) {
      dayName = 'pasado mañana, ' + DAYS_ES[date.getDay()];
    } else {
      dayName = 'el ' + DAYS_ES[date.getDay()] + ' ' + date.getDate() + ' de ' + MONTHS_ES[date.getMonth()];
    }

    var suffix = locationLabel ? ' en ' + locationLabel : '';

    if (type === 'messenger' && diffDays <= 1) {
      var hours = date.getHours();
      var mins = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var h12 = hours % 12;
      if (h12 === 0) h12 = 12;
      var timeStr = h12 + ':' + (mins < 10 ? '0' : '') + mins + ' ' + ampm;
      return 'Recíbelo ' + dayName + ' a las ' + timeStr + suffix;
    } else {
      return 'Recíbelo ' + dayName + suffix;
    }
  }

  function getCentroid(geometry) {
    var coords;
    if (geometry.type === 'Polygon') {
      coords = geometry.coordinates[0];
    } else if (geometry.type === 'MultiPolygon') {
      coords = geometry.coordinates[0][0];
    } else {
      return null;
    }
    var sumLng = 0, sumLat = 0;
    for (var i = 0; i < coords.length; i++) {
      sumLng += coords[i][0];
      sumLat += coords[i][1];
    }
    return [sumLat / coords.length, sumLng / coords.length];
  }

  function DeliveryEstimator(containerId) {
    this.container = document.getElementById(containerId);
    if (!this.container) return;

    this.config = this.loadConfig();
    if (!this.config) return;

    this.productType = this.container.getAttribute('data-product-type') || 'immediate';
    this.hasStockXela = this.container.hasAttribute('data-stock-xela');
    this.map = null;
    this.deptSelect = this.container.querySelector('.delivery-dept-select');
    this.muniSelect = this.container.querySelector('.delivery-muni-select');
    this.resultArea = this.container.querySelector('.delivery-result');
    this.resultText = this.container.querySelector('.delivery-result-text');
    this.resultMethod = this.container.querySelector('.delivery-result-method');
    this.resultIcon = this.container.querySelector('.delivery-result-icon');
    this.geoBtn = this.container.querySelector('.delivery-geo-btn');
    this.loadingEl = this.container.querySelector('.delivery-loading');
    this.initialEl = this.container.querySelector('.delivery-estimator__initial');
    this.countdownEl = this.container.querySelector('.delivery-estimator__result-countdown');
    this.countdownInterval = null;
    this.addToCartBtn = this.container.querySelector('.delivery-estimator__add-to-cart');
    this.locationSummary = this.container.querySelector('.delivery-estimator__location-summary');
    this.locationText = this.container.querySelector('.delivery-estimator__location-text');
    this.locationChangeBtn = this.container.querySelector('.delivery-estimator__location-change');
    this.deptMuniList = null;
    this._loadingFromCookie = false;

    this.init();
  }

  DeliveryEstimator.prototype.loadConfig = function() {
    var el = document.getElementById('delivery-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch(e) {
      return null;
    }
  };

  DeliveryEstimator.prototype.init = function() {
    var self = this;
    this.initMap();
    this.loadDeptMuniList().then(function() {
      self.populateDepartments();
      self.bindEvents();
      self.loadFromCookie();
    });
  };

  DeliveryEstimator.prototype.loadFromCookie = function() {
    if (!window.CelovendoLocation) {
      var self = this;
      document.addEventListener('cv:location-ready', function handler() {
        document.removeEventListener('cv:location-ready', handler);
        self.loadFromCookie();
      });
      return;
    }
    var loc = window.CelovendoLocation.getLocation();
    if (!loc || !loc.dept || !loc.muni || !loc.confirmed) return;
    var self = this;
    if (this.deptSelect) {
      var deptVal = this.findOptionValue(this.deptSelect, loc.dept);
      if (deptVal) {
        this.deptSelect.value = deptVal;
        this.populateMunicipios(deptVal);
        if (this.muniSelect) {
          var muniVal = this.findOptionValue(this.muniSelect, loc.muni);
          if (muniVal) this.muniSelect.value = muniVal;
        }
      }
    }
    if (loc.lat && loc.lng) {
      this._loadingFromCookie = true;
      this.setMarker(loc.lat, loc.lng, 12);
      var self2 = this;
      var clearFlag = function() {
        setTimeout(function() { self2._loadingFromCookie = false; }, 50);
      };
      if (this.map) {
        this.map.once('moveend', clearFlag);
        setTimeout(function() { self2._loadingFromCookie = false; }, 1000);
      } else {
        this._loadingFromCookie = false;
      }
      if (loc.zone) {
        self.showResult({
          zone: loc.zone,
          municipio: loc.muni,
          departamento: loc.dept,
          cityZone: loc.cityZone || null
        }, true);
      } else {
        findDeliveryZone(loc.lat, loc.lng, this.config).then(function(zoneInfo) {
          self.showResult(zoneInfo, true);
        }).catch(function() {});
      }
    }
  };

  DeliveryEstimator.prototype.initMap = function() {
    var mapEl = this.container.querySelector('.delivery-map');
    if (!mapEl || typeof L === 'undefined') return;

    this.map = L.map(mapEl, {
      center: [14.6, -90.5],
      zoom: 8,
      scrollWheelZoom: true,
      zoomControl: true,
      dragging: true
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap',
      maxZoom: 18
    }).addTo(this.map);

    this.centerPin = this.container.querySelector('.delivery-estimator__center-pin');
    this.mapHint = this.container.querySelector('.delivery-estimator__map-hint');
    this.moveTimeout = null;
    this.mapMoveCount = 0;
    this.mapMovesRequired = 2;

    var self = this;
    this.map.on('movestart', function() {
      if (self.centerPin) self.centerPin.classList.add('delivery-estimator__center-pin--dragging');
    });
    this.map.on('moveend', function() {
      if (self.centerPin) self.centerPin.classList.remove('delivery-estimator__center-pin--dragging');
      if (self._loadingFromCookie) return;
      self.mapMoveCount++;
      if (self.mapMoveCount < self.mapMovesRequired) return;
      clearTimeout(self.moveTimeout);
      self.moveTimeout = setTimeout(function() {
        var center = self.map.getCenter();
        self.onMapMove(center.lat, center.lng);
      }, 400);
    });

    setTimeout(function() {
      if (self.map) self.map.invalidateSize();
    }, 300);
  };

  DeliveryEstimator.prototype.loadDeptMuniList = function() {
    var self = this;
    if (this.deptMuniList) return Promise.resolve();
    var url = this.config.geoJsonUrls.deptMuniList;
    return fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        self.deptMuniList = data;
      })
      .catch(function() {
        self.deptMuniList = {};
      });
  };

  DeliveryEstimator.prototype.populateDepartments = function() {
    if (!this.deptSelect || !this.deptMuniList) return;
    this.deptSelect.innerHTML = '<option value="">Selecciona departamento</option>';
    var depts = Object.keys(this.deptMuniList).sort();
    for (var i = 0; i < depts.length; i++) {
      var opt = document.createElement('option');
      opt.value = depts[i];
      opt.textContent = depts[i];
      this.deptSelect.appendChild(opt);
    }
  };

  DeliveryEstimator.prototype.populateMunicipios = function(dept) {
    if (!this.muniSelect || !this.deptMuniList) return;
    this.muniSelect.innerHTML = '<option value="">Selecciona municipio</option>';
    if (!dept || !this.deptMuniList[dept]) {
      this.muniSelect.disabled = true;
      return;
    }
    this.muniSelect.disabled = false;
    var munis = this.deptMuniList[dept].sort();
    for (var i = 0; i < munis.length; i++) {
      var opt = document.createElement('option');
      opt.value = munis[i];
      opt.textContent = munis[i];
      this.muniSelect.appendChild(opt);
    }
  };

  DeliveryEstimator.prototype.bindEvents = function() {
    var self = this;

    if (this.deptSelect) {
      this.deptSelect.addEventListener('change', function() {
        self.populateMunicipios(this.value);
        self.hideResult();
      });
    }

    if (this.muniSelect) {
      this.muniSelect.addEventListener('change', function() {
        if (this.value) {
          self.onMunicipioSelected(self.deptSelect.value, this.value);
        }
      });
    }

    if (this.geoBtn) {
      this.geoBtn.addEventListener('click', function() {
        self.useGeolocation();
      });
    }

    if (this.addToCartBtn) {
      this.addToCartBtn.addEventListener('click', function() {
        var realBtn = document.querySelector('.product-form__add-button[data-action="add-to-cart"]');
        if (realBtn && !realBtn.disabled) realBtn.click();
      });
    }

    if (this.locationChangeBtn) {
      this.locationChangeBtn.addEventListener('click', function() {
        self.expandControls();
      });
    }

    var geoBtnMini = this.container.querySelector('.delivery-geo-btn-mini');
    if (geoBtnMini) {
      geoBtnMini.addEventListener('click', function() {
        self.useGeolocation();
      });
    }

    var geoBtnMap = this.container.querySelector('.delivery-geo-btn-map');
    if (geoBtnMap) {
      geoBtnMap.addEventListener('click', function() {
        self.useGeolocation();
      });
    }
  };

  DeliveryEstimator.prototype.onMapMove = function(lat, lng) {
    if (this.mapHint) this.mapHint.classList.add('delivery-estimator__map-hint--hidden');
    this.showLoading();
    var self = this;
    findDeliveryZone(lat, lng, this.config).then(function(zoneInfo) {
      self.updateDropdownsFromZone(zoneInfo);
      self.showResult(zoneInfo);
    }).catch(function() {
      self.showError('No se pudo determinar la ubicación.');
    });
  };

  DeliveryEstimator.prototype.onMunicipioSelected = function(dept, muni) {
    this.showLoading();
    var self = this;
    var url = this.config.geoJsonUrls.municipios;
    loadGeoJSON(url).then(function(data) {
      var feature = null;
      for (var i = 0; i < data.features.length; i++) {
        var f = data.features[i];
        var fMuni = (f.properties.municipio || f.properties.MUNICIPIO || '').toLowerCase();
        var fDept = (f.properties.departamen || f.properties.DEPARTAMEN || f.properties.departamento || '').toLowerCase();
        if (fMuni === muni.toLowerCase() && fDept === dept.toLowerCase()) {
          feature = f;
          break;
        }
      }

      if (feature) {
        var centroid = getCentroid(feature.geometry);
        if (centroid) {
          self.setMarker(centroid[0], centroid[1], 12);
        }
        var lat = centroid ? centroid[0] : 14.6;
        var lng = centroid ? centroid[1] : -90.5;
        return findDeliveryZone(lat, lng, self.config);
      } else {
        return { zone: 'cargo_expreso', municipio: muni, departamento: dept };
      }
    }).then(function(zoneInfo) {
      self.showResult(zoneInfo);
    }).catch(function() {
      self.showError('No se pudo calcular la estimación.');
    });
  };

  DeliveryEstimator.prototype.useGeolocation = function() {
    if (!navigator.geolocation) {
      this.showError('Tu navegador no soporta geolocalización.');
      return;
    }
    if (this.mapHint) this.mapHint.classList.add('delivery-estimator__map-hint--hidden');
    this.mapMoveCount = this.mapMovesRequired;
    this.showLoading();
    var self = this;
    navigator.geolocation.getCurrentPosition(function(pos) {
      var lat = pos.coords.latitude;
      var lng = pos.coords.longitude;
      self.setMarker(lat, lng, 16);
      findDeliveryZone(lat, lng, self.config).then(function(zoneInfo) {
        self.updateDropdownsFromZone(zoneInfo);
        self.showResult(zoneInfo);
      }).catch(function() {
        self.showError('No se pudo determinar tu ubicación.');
      });
    }, function() {
      self.showError('No se pudo obtener tu ubicación. Verifica los permisos.');
    }, { enableHighAccuracy: false, timeout: 10000 });
  };

  DeliveryEstimator.prototype.setMarker = function(lat, lng, zoom) {
    if (!this.map) return;
    this.map.setView([lat, lng], zoom || Math.max(this.map.getZoom(), 10));
  };

  DeliveryEstimator.prototype.updateDropdownsFromZone = function(zoneInfo) {
    if (!zoneInfo.departamento || !zoneInfo.municipio) return;
    if (this.deptSelect) {
      var deptVal = this.findOptionValue(this.deptSelect, zoneInfo.departamento);
      if (deptVal) {
        this.deptSelect.value = deptVal;
        this.populateMunicipios(deptVal);
        if (this.muniSelect) {
          var muniVal = this.findOptionValue(this.muniSelect, zoneInfo.municipio);
          if (muniVal) this.muniSelect.value = muniVal;
        }
      }
    }
  };

  DeliveryEstimator.prototype.findOptionValue = function(select, text) {
    if (!text) return null;
    var lower = text.toLowerCase();
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value.toLowerCase() === lower) {
        return select.options[i].value;
      }
    }
    return null;
  };

  DeliveryEstimator.prototype.stopCountdown = function() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
    if (this.countdownEl) {
      this.countdownEl.textContent = '';
      this.countdownEl.classList.remove('delivery-estimator__result-countdown--visible');
    }
  };

  DeliveryEstimator.prototype.startCountdown = function(config) {
    this.stopCountdown();
    if (!this.countdownEl || !config.urgency) return;

    var now = getNowGT();
    var dayKey = String(now.getDay());
    var dayCfg = config.urgency[dayKey];
    if (!dayCfg || !dayCfg.visible) return;

    var cutoffTime = new Date(now.getTime());
    cutoffTime.setHours(dayCfg.hour, dayCfg.minute, 0, 0);

    var remainingMs = cutoffTime.getTime() - now.getTime();
    if (remainingMs <= 0) return;

    var self = this;

    function formatCountdown(ms) {
      var totalSec = Math.floor(ms / 1000);
      var h = Math.floor(totalSec / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;
      var parts = [];
      if (h > 0) parts.push(String(h).padStart(2, '0'));
      parts.push(String(m).padStart(2, '0'));
      parts.push(String(s).padStart(2, '0'));
      return parts.join(':');
    }

    function updateDisplay() {
      var now2 = getNowGT();
      var remaining = cutoffTime.getTime() - now2.getTime();
      if (remaining <= 0) {
        self.stopCountdown();
        return;
      }
      self.countdownEl.innerHTML = '\u26A1 Ordena en los pr\u00F3ximos <span class="countdown-timer">' + formatCountdown(remaining) + '</span>';
      self.countdownEl.classList.add('delivery-estimator__result-countdown--visible');
    }

    updateDisplay();
    this.countdownInterval = setInterval(updateDisplay, 1000);
  };

  DeliveryEstimator.prototype.showResult = function(zoneInfo, fromCookie) {
    this.hideLoading();
    this.stopCountdown();
    if (this.initialEl) this.initialEl.style.display = 'none';
    if (!zoneInfo || zoneInfo.zone === 'outside') {
      this.showError('Ubicación fuera de Guatemala. Solo realizamos envíos dentro de Guatemala.');
      return;
    }

    var effectiveType = this.productType;
    if (effectiveType === 'immediate' && this.hasStockXela && zoneInfo.zone === 'messenger_xela') {
      effectiveType = 'xela';
    }
    var estimate = calculateEstimate(zoneInfo, effectiveType, this.config);
    if (!estimate) {
      this.showError('No se pudo calcular la estimación de entrega.');
      return;
    }

    if (fromCookie) {
      this.populateInlineResult(estimate);
      return;
    }

    if (!fromCookie && window.CelovendoLocation && zoneInfo.municipio && zoneInfo.departamento) {
      var mapCenter = this.map ? this.map.getCenter() : null;
      var lat = mapCenter ? mapCenter.lat : 14.6349;
      var lng = mapCenter ? mapCenter.lng : -90.5069;
      window.CelovendoLocation.setLocation(zoneInfo.departamento, zoneInfo.municipio, lat, lng, zoneInfo.zone, zoneInfo.cityZone);
    }

    this.showResultFull(estimate);
  };

  DeliveryEstimator.prototype.showResultFull = function(estimate) {
    if (this.resultArea) {
      this.resultArea.style.display = 'flex';
      this.resultArea.classList.remove('delivery-estimator__result--error');
      this.resultArea.classList.add('delivery-estimator__result--visible');
    }
    if (this.resultText) this.resultText.textContent = estimate.formatted;
    if (this.resultMethod) {
      var methodText = estimate.method;
      if (estimate.municipio) {
        methodText += ' — ' + estimate.municipio;
        if (estimate.departamento) methodText += ', ' + estimate.departamento;
      }
      this.resultMethod.textContent = methodText;
    }
    if (this.resultIcon) {
      if (estimate.type === 'messenger') {
        this.resultIcon.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ff9b00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>';
      } else {
        this.resultIcon.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ff9b00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
      }
    }
    this.startCountdown(this.config);
    if (this.addToCartBtn) this.addToCartBtn.classList.add('delivery-estimator__add-to-cart--visible');
    this.collapseControls();
  };

  DeliveryEstimator.prototype.populateInlineResult = function(estimate) {
    var inlineEl = document.getElementById('delivery-inline-result');
    if (!inlineEl) {
      this.showResultFull(estimate);
      return;
    }

    var pill = document.querySelector('.delivery-pill');
    if (pill) {
      var pillStyle = getComputedStyle(pill);
      inlineEl.style.setProperty('--inline-bg', pillStyle.getPropertyValue('--pill-bg').trim() || '#e8f5e9');
      inlineEl.style.setProperty('--inline-border', pillStyle.getPropertyValue('--pill-border').trim() || '#a5d6a7');
      inlineEl.style.setProperty('--inline-color', pillStyle.getPropertyValue('--pill-color').trim() || '#2e7d32');
    }

    var iconEl = inlineEl.querySelector('.delivery-inline-result__icon');
    var dateEl = inlineEl.querySelector('.delivery-inline-result__date');
    var methodEl = inlineEl.querySelector('.delivery-inline-result__method');

    if (dateEl) dateEl.textContent = estimate.formatted;
    if (methodEl) {
      var methodText = estimate.method;
      if (estimate.municipio) {
        methodText += ' — ' + estimate.municipio;
        if (estimate.departamento) methodText += ', ' + estimate.departamento;
      }
      methodEl.textContent = methodText;
    }
    if (iconEl) {
      if (estimate.type === 'messenger') {
        iconEl.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>';
      } else {
        iconEl.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
      }
    }

    var shippingCard = this.container.closest('.product-block-list__item--shipping');
    if (shippingCard) shippingCard.style.display = 'none';

    inlineEl.style.display = 'flex';
    requestAnimationFrame(function() {
      inlineEl.classList.add('delivery-inline-result--visible');
    });
  };

  DeliveryEstimator.prototype.showError = function(msg) {
    this.hideLoading();
    this.stopCountdown();
    if (this.addToCartBtn) this.addToCartBtn.classList.remove('delivery-estimator__add-to-cart--visible');
    this.expandControls();
    if (this.initialEl) this.initialEl.style.display = 'none';
    if (this.resultArea) {
      this.resultArea.style.display = 'flex';
      this.resultArea.classList.add('delivery-estimator__result--visible');
      this.resultArea.classList.add('delivery-estimator__result--error');
    }
    if (this.resultText) this.resultText.textContent = msg;
    if (this.resultMethod) this.resultMethod.textContent = '';
    if (this.resultIcon) {
      this.resultIcon.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#e74c3c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>';
    }
  };

  DeliveryEstimator.prototype.collapseControls = function() {
    var dept = this.deptSelect ? this.deptSelect.options[this.deptSelect.selectedIndex] : null;
    var muni = this.muniSelect ? this.muniSelect.options[this.muniSelect.selectedIndex] : null;
    var deptName = dept && dept.value ? dept.text : '';
    var muniName = muni && muni.value ? muni.text : '';
    var label = muniName && deptName ? muniName + ', ' + deptName : deptName || 'Ubicación seleccionada';
    if (this.locationText) this.locationText.textContent = label;
    this.container.classList.add('delivery-estimator--collapsed');
  };

  DeliveryEstimator.prototype.expandControls = function() {
    this.container.classList.remove('delivery-estimator--collapsed');
  };

  DeliveryEstimator.prototype.hideResult = function() {
    this.stopCountdown();
    if (this.addToCartBtn) this.addToCartBtn.classList.remove('delivery-estimator__add-to-cart--visible');
    if (this.resultArea) {
      this.resultArea.style.display = 'none';
      this.resultArea.classList.remove('delivery-estimator__result--visible');
      this.resultArea.classList.remove('delivery-estimator__result--error');
    }
    if (this.initialEl) this.initialEl.style.display = '';
  };

  DeliveryEstimator.prototype.showLoading = function() {
    this.hideResult();
    if (this.loadingEl) this.loadingEl.style.display = 'flex';
  };

  DeliveryEstimator.prototype.hideLoading = function() {
    if (this.loadingEl) this.loadingEl.style.display = 'none';
  };

  window.DeliveryEstimator = DeliveryEstimator;
  window.calculateDeliveryEstimate = calculateEstimate;
  window.findDeliveryZone = findDeliveryZone;

  var activeEstimator = null;

  document.addEventListener('DOMContentLoaded', function() {
    var container = document.getElementById('delivery-estimator');
    if (container) {
      activeEstimator = new DeliveryEstimator('delivery-estimator');
    }
  });

  document.addEventListener('cv:location-changed', function() {
    if (activeEstimator) {
      activeEstimator.loadFromCookie();
    }
  });

  document.addEventListener('cv:location-ready', function() {
    if (activeEstimator) {
      activeEstimator.loadFromCookie();
    }
  });
})();
